import { ICustomDocumentTypesMap, IEntityDocument, UUID } from "src/app/core/interfaces";

export interface DocumentsModel {
  isDocumentsLoading: boolean,
  documentsMap: {[documentId in UUID]?: IEntityDocument},
  customDocumentTypesMap: { [orgId in UUID]: ICustomDocumentTypesMap };
  isCustomDocumentTypesLoading: boolean;
}

export const defaultDocumentsState: DocumentsModel = {
  isDocumentsLoading: false,
  documentsMap: {},
  customDocumentTypesMap: {},
  isCustomDocumentTypesLoading: false,
};
